<template>
  <div>
    <ShopOrderSelectModal
      ref="shopOrderSelectModal"
      :shop_order="shop_order"
      @selectedShopItem="selectedShopItem"
    />


    <memlist-static-table
      id="items-table"
      style="width: 100%;"
      class="table-striped"
      :fields="showFields"
      :items="items"
      head-variant="light"
      ref="items-table"
    >

    </memlist-static-table>

  </div>
</template>

<script>
import axios from 'axios';

import ShopOrderSelectModal from "@/view/pages/ml/shop_order/ShopOrderSelectModal.vue";

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


export default {
  name: "shop_order_item-table",
  props: ["items","shop_order"],
  emits: ['select_shop_item', 'addShopItemClicked', 'edit_shop_item_clicked', 'delete_shop_item_clicked'],
  components: {
    ShopOrderSelectModal
  },
  mixins: [toasts],
  methods: {
    selectedShopItem(shop_item_id, name) {
      this.$emit('select_shop_item', shop_item_id, name);
    },
    addShopItemClicked() {
      //this.$emit('addShopItemClicked');
      this.$refs['shopOrderSelectModal'].show();
    },
    editShopItemClicked(shop_item_id) {
      this.$emit('edit_shop_item_clicked', shop_item_id);
    },
    delete_shop_item_clicked(shop_item_id) {
      this.$emit('delete_shop_item_clicked', shop_item_id);
    },
    maxLengthOfCell(str, length) {
      return str && str.length > length ? str.substring(0, length) + '...' : str;
    },
    updateItems() {

      this.$forceUpdate();

    },

  },
  data() {
    return {

      perPage: 25,
      currentPage: 1,
      options: [25, 50, 100],
      showFields: [
        { 
          key: 'name', 
          label: this.$t('SHOP_ORDER.ARTICLE'), 
          show: true, 
          sortable: true, 
          thClass: 'pl-7 w-100', 
          tdClass: 'pl-7',
          formatter: (_, __, item) => {
            if (item.shop_item.company) {
              return `(${item.shop_item.company.name}) ${item.shop_item.name}`;
            }

            return item.shop_item.name;
          }
        },
        { 
          key: 'amount', 
          label: this.$t('SHOP_ORDER.AMOUNT'), 
          show: true, 
          sortable: true, 
          thClass: 'td-short5', 
          tdClass: 'td-short5',
          formatter: (_, __, item) => {
            return item.shop_item.amount
          }
        },
        { 
          key: 'actions', 
          label: this.$t('COMMON.ACTIONS'),
          show: true, 
          sortable: false
        }
      ],
      filter: '',
      list: [

      ]
    };
  }
};
</script>
